<template>
  <span
    class="opening-type-text"
    :class="{ 'opening-type-text--clickable': collapsible }"
    @click.stop="toggle"
  >
    <template v-if="expanded || !collapsible">
      <span
        v-for="(item, index) in openingTypeItems"
        :key="`full-${item.value}-${index}`"
        class="opening-type-text__item"
      >
        <span v-if="index">, </span>
        <span>{{ item.label }}</span>
        <slot name="after" :type="item.value" :label="item.label" :index="index" />
      </span>
    </template>
    <template v-else>
      <span
        v-for="(item, index) in collapsedOpeningTypeItems"
        :key="`collapsed-${item.value}-${index}`"
        class="opening-type-text__item"
      >
        <span v-if="index">, </span>
        <span>{{ item.label }}</span>
        <slot name="after" :type="item.value" :label="item.label" :index="index" />
      </span>
      <span>…</span>
    </template>
  </span>
</template>

<script>
import {
  OPENING_TYPES,
  parseOpeningTypeValues,
  hasManyOpeningTypes,
} from './consts';

export default {
  name: 'OpeningTypeText',
  props: {
    openingType: {
      type: [String, Array],
      default: null,
    },
  },
  data () {
    return {
      expanded: false,
    };
  },
  computed: {
    openingTypeItems () {
      return parseOpeningTypeValues(this.openingType)
        .map(value => ({
          value,
          label: OPENING_TYPES[value],
        }))
        .filter(item => item.label);
    },
    collapsedOpeningTypeItems () {
      return this.openingTypeItems.slice(0, 2);
    },
    collapsible () {
      return hasManyOpeningTypes(this.openingType);
    },
  },
  watch: {
    openingType () {
      this.expanded = false;
    },
  },
  methods: {
    toggle () {
      if (!this.collapsible) {
        return;
      }
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped>
.opening-type-text--clickable {
  cursor: pointer;
}

.opening-type-text--clickable:hover {
  color: #0d4092;
}

.opening-type-text__item {
  display: inline;
}
</style>
